// extracted by mini-css-extract-plugin
export var avatarContainer = "_4a-1";
export var largeAvatarContainer = "_4a-2";
export var smallAvatarContainer = "_4a-0";